module.exports = __webpack_public_path__ + "img/icon-x.22d25c85.svg";